import React from "react";

const Loader = () => {
    return (<div className="images-preloader">
        <div id="preloader_1" className="rectangle-bounce">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>);
}

export default Loader;